<template>
  <div class="list-mode">
    <span
      class="mb-3 grey--text subheading"
      v-if="searchDocumentString.length > 0"
    >
      {{ documents.length }} resultado{{ documents.length !== 1 ? 's' : '' }} com o termo "{{searchDocumentString}}"
    </span>
    <document-list
      :documents="DocumentList"
      v-if="DocumentList.length > 0"
      :searchDocumentString="searchDocumentString"
    />
    <other-file-list
      :documents="OtherFileList"
      v-if="OtherFileList.length > 0"
      :searchDocumentString="searchDocumentString"
    />
    <attached-folders-list
      :currentFolder="folder"
    />
  </div>
</template>

<script>
import DocumentList from './DocumentList';
import OtherFileList from './OtherFileList';
import AttachedFoldersList from '@/components/folder/list/AttachedFoldersList';

export default {
  name: 'ListMode',
  props: {
    documents: {
      default: [],
      type: Array,
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
    folder: {
      type: Object,
    },
  },
  components: {
    DocumentList,
    OtherFileList,
    AttachedFoldersList,
  },
  computed: {
    DocumentList() {
      return this.documents.filter(item => item.mime_type === 'application/pdf');
    },
    OtherFileList() {
      return this.documents.filter(item => item.mime_type !== 'application/pdf');
    },
  },
};
</script>

<style lang="scss">
.list-mode {
/*  overflow-y: auto;
  height: calc(100vh - 64px);*/
}

.document-table {
  .v-table__overflow {
    overflow: initial;
  }
  .v-table {
    background: transparent !important;

    thead {
      tr {
        height: 32px;
        border-bottom-color: rgba(0,0,0,.06) !important;
        border-left-color: transparent;
        border-right-color: transparent;
      }
      th {
        padding: 0 .5rem !important;
      }
    }
    tbody {
      border-bottom: 1px solid rgba(0,0,0,.12);

      td {
        position: relative;
      }
    }
    tr {
      position: relative;
      border-left: 1px solid rgba(0,0,0,.12);
      border-right: 1px solid rgba(0,0,0,.12);

      &:hover {
        .has-pending {
          background: none;
        }
      }

      .has-pending {
        z-index: 2;
        position: absolute;
        top: calc(50% - 6px);
        left: -6px;
        background: #fff;
        border: 2px solid #fff;
        border-radius: 50%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/document/list/ListMode.vue